package cz.lhoracek.mapl.data.model

enum class Suit(val label: String, val symbol: String) {
    ZALUDY("Žaludy", "🌰"),
    KULE("Kule", "🔔"),
    ZELENE("Listy", "🍃"),
    LEPSI("Lepší", "♥"),
}
